import React, { Dispatch, memo, SetStateAction } from "react";

import NonLabMacroFilter, {
  INonLabFilterParams,
} from "../NonLabShared/NonLabMacroFilter";

interface IMacroFilterProps {
  onFilterParams: Dispatch<SetStateAction<IFilterParams>>;
  filterParams: IFilterParams;
}

export interface IFilterParams extends INonLabFilterParams {
  IndividualDocumentOS: string;
}

const translationPath = "page.4uBus.logs.tasyToTasyResultsNonLabReceived.";

const MacroFilter: React.FC<IMacroFilterProps> = (props) => (
  <NonLabMacroFilter
    {...props}
    translationPath={translationPath}
    documentField="IndividualDocumentOS"
  />
);

export default memo(MacroFilter);
